import { userList } from "./user-list/user-list.module";
import { userEdit } from "./user-edit/user-edit.module";
import { userDetail } from "./user-details/user-details.module";
import { userAddNote } from "./user-add-note/user-add-note.module";
import { userEditNote } from "./user-edit-note/user-edit-note.module";
import { userNoteMain } from "./user-note-main/user-note-main.module";
import { userSendNotification } from "./user-send-notification/user-send-notification.module";
import { UserService } from "./user.service";
import "./user.scss";

export const user = angular
  .module("components.user", [
    userList,
    userEdit,
    userDetail,
    userAddNote,
    userNoteMain,
    userEditNote,
    userSendNotification,
  ])
  .service("UserService", UserService).name;



// WEBPACK FOOTER //
// ./src/app/components/user/user.module.js